import React from "react"
import { default as RCSlider } from "rc-slider"
import "twin.macro"
import "rc-slider/assets/index.css"
import tw, { css } from "twin.macro"

export type SliderProps = {
  maxValue?: number
  minValue?: number
  initialValue?: number
  onValueChange?: (value: number) => void
}

export const Slider = ({
  onValueChange,
  maxValue = 100,
  minValue = 0,
  initialValue = 0,
}: SliderProps) => {
  return (
    <div tw="w-full h-full relative block">
      <RCSlider
        css={css`
          & .rc-slider-handle {
            ${tw`w-6 h-6 -ml-3! transform! translate-x-0.5! translate-y-1/2! border-primary-dark hocus:border-primary-regular border-4 shadow-md active:shadow-none`}
          }

          & .rc-slider-track {
            ${tw`bg-primary-regular`}
          }
        `}
        defaultValue={initialValue}
        min={minValue}
        max={maxValue}
        onChange={onValueChange}
        vertical
      ></RCSlider>
    </div>
  )
}
